var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { TabGroupItem } from './TabGroupItem';
import { TabAction } from './components';
import { wrapChildren } from '../../utilities/wrapChildren';
import { useArrowNav } from '../../hooks/useArrowNav';
export const TabGroup = (_a) => {
    var { action, children, className, dark, divider = true, fitted, size = 'normal', maxWidth, verticallyDivided, type = 'underline', textAlign = 'center' } = _a, props = __rest(_a, ["action", "children", "className", "dark", "divider", "fitted", "size", "maxWidth", "verticallyDivided", "type", "textAlign"]);
    const TabGroupClasses = classnames('TabGroup', className, {
        'TabGroup--fitted': fitted,
        'TabGroup--dark': dark,
        'TabGroup--index': type === 'index',
        'TabGroup--underline': type === 'underline',
        'TabGroup--leftAlign': textAlign === 'left',
        'TabGroup--large': size === 'large',
        'TabGroup--divider': divider,
        'TabGroup--maxWidth': maxWidth,
        'TabGroup--verticallyDivided': verticallyDivided,
    });
    const tabGroupRef = useArrowNav({
        handleY: false,
        focusableSelector: {
            selector: '[role=tab]:not([disabled]):not([aria-disabled])',
        },
    });
    return (React.createElement("ul", Object.assign({ role: "tablist", className: TabGroupClasses, "data-anvil-component": "TabGroup", ref: tabGroupRef }, props),
        wrapChildren(children, TabGroupItem),
        action && React.createElement(TabAction, null, action)));
};
TabGroup.Action = TabAction;
//# sourceMappingURL=TabGroup.js.map